@if (meeting) {
    <div class="location-name-container" (click)="toggleTournamentSelector(meetings, meeting, dayOfRace, futureFixtures)">
        <span class="location-name"> {{ meeting.name | msTranslate }} </span>
        @if (meetings) {
            <a class="open-tournament-list">
                <vn-icon size="14" class="sports-icon chevron-icon" [name]="tournamentSelectorOpen ? 'theme-up' : 'theme-down'" />
            </a>
        }
    </div>
} @else {
    <div class="location-name-container">
        <span class="location-name"> {{ sitecore.horseRacing.common.HorsesLinkText }} </span>
    </div>
}
<div class="tournament-selector-container">
    <ms-horses-tournament-selector />
</div>
